/**
 * Catch Board info-tip copy — sales-facing explanations for The Bridge kanban.
 */

export const CATCH_BOARD_TOOLTIPS = Object.freeze({
  momentum:
    'Open-pipeline deal count and £ vs 7 days ago (same filters as the board). Closed stages are excluded — a column can shrink when deals progress, and that’s healthy.',
  pipelineValue:
    'Sum of deal value (£) on open-pipeline deals matching the current filters. Landed / Got Away are excluded even when Hide closed is off.',
  potentialValue:
    'Sum of potential value (£) on open-pipeline deals — upside if they land at potential. Closed stages are excluded. Not the same as Pipeline.',
  readinessFilter:
    'Internal queue for who needs to unblock the deal next (Sales / CS / Product) — not the same as pipeline stage.',
  readinessChips: Object.freeze({
    sales_ready: 'Sales ready — no CS/product blocker; sales can progress.',
    customer_success:
      'CS needed — customer success should unblock before sales progresses.',
    product:
      'Product needed — a product answer/fix is blocking sales progress.',
  }),
  duplicateVenueWarn:
    'Warning only — you can still save. This venue is already on another open deal.',
})

export function getCatchBoardReadinessChipTip(readiness) {
  return CATCH_BOARD_TOOLTIPS.readinessChips[readiness] || null
}
